export default {
    passwordService: 'C1s4ngg1r1!@',
    // PROD
     baseApi: "https://mdrxdash.damcorp.id/api/v1/",
     socket: "https://waba.damcorp.id/",
     recaptcha: {
        sitekey: "6LeMqkggAAAAAFmIsKTePbeN3YrmZZih7n7LYgaI"
      },
    // DEV
    // baseApi: "https://xdash-dev.damcorp.id/api/v1/",
    // socket: "https://dev-chitchat.damcorp.id/",
    // recaptcha: {
    //   sitekey: "6Ld0CZcUAAAAANa3--T_XYoVvr9yMkaxJxFOswoV"
    // },
    // LOCAL
    //baseApi: "http://localhost:6988/api/v1/",
    //recaptcha: {
    //  sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
   // },
    privateKey: `-----BEGIN RSA PUBLIC KEY-----
    MIIBCgKCAQEAqvoj6GHL7IUEPg0/uVHIJDqFUebmghK5Y9YZgLInIhhs6m3Emfcp
    ixojXBJvYl+GRPN5/AtjnV/yP7j/nPjFHqt4/5SynBWERbGm/7S4BtAlBXgMKKHj
    Di9VvYtNBR1Ybjj93IJY8umREhhh9asIuaNwN3shNMFTB0Cf/nArivcUV5qmia07
    y3NqPVO88Zj2Qscq+/g86rQHaM2XAMwY5sBiVQ/0n3oMGVp8ca8yzZvbKcLuKvbb
    JviLMPrxYJCrdHkFvLftjRub3TXuqmSNIfJ4tCQwWaxismKTE7vsUGaajOE1S8CR
    p8eJbv5dKsC5I8NkZNbjfX32EfcxN0DfbQIDAQAB
    -----END RSA PUBLIC KEY-----`
  }
  
  
